import { newToolFilterOAuthMcp } from "../oauth.ts";

export const daloopaMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://daloopa.com/wp-content/uploads/2026/02/cropped-Favicon-Light-192x192.png",
  url: "https://mcp.daloopa.com/server/mcp",
  label: "Daloopa",
});
